import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import Invoice from "./Invoice";
import { HiOutlineDownload } from "react-icons/hi";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { _get, _post } from "../services/apiClient";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRestaurantConfig } from "../hooks/useRestaurantConfig";
import { formatDateTimeInTimezone } from "../helper/dateTimeUtils";
import { formatCurrency } from "../helper/formatCurrency";
import { getAppConfig } from "../utilis/appConfig";
const DEFAULT_IMAGE = "/img/finglider_logo.jpg";

const styles = {
  btn: {
    borderRadius: "3px",
    border: "1px solid gray",
    display: "flex",
    alignItems: "center",
    gap: "2px",
    padding: "3px",
    fontSize: "11px",
    color: "#4f4f4f",
    fontWeight: 600,
    cursor: "pointer",
    userSelect: "none",
  },
};

const Orders = () => {
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const [activeTab, setActiveTab] = useState("On Process");
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;
  const [showFeedbackFor, setShowFeedbackFor] = useState(null);
  const [overallRating, setOverallRating] = useState(0);
  const [comment, setComment] = useState("");
  const [itemRatings, setItemRatings] = useState({});
  const [submittedFeedbackOrders, setSubmittedFeedbackOrders] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const { locale, timezone } = useRestaurantConfig();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { defaultImage } = getAppConfig();

  const loadSubmittedFeedbacks = async (userId) => {
    const res = await _get(`/feedbacks/submitted/user/${userId}`);
    if (res.data.success) {
      setSubmittedFeedbackOrders(res.data.orderIds);
    }
  };


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    setOrderHistoryData([]);
    setLoading(true);

    try {
      const decoded = jwtDecode(token);

      if (decoded?.id) {
        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              const user = res.data.user;
              setUserInfo({
                id: user._id,
              });
              loadSubmittedFeedbacks(user._id);

              fetchOrderHistory(user._id);
            } else {
              setOrderHistoryData([]);
              setLoading(false);
            }
          } catch (err) {
            console.error("Failed to fetch user:", err);
            setOrderHistoryData([]);
            setLoading(false);
          }
        };

        fetchUserDetails();
      }
    } catch (err) {
      console.error("Invalid JWT:", err);
      setOrderHistoryData([]);
      setLoading(false);
    }

    setCurrentPage(1);
  }, [activeTab]);

  const StarRating = ({ value, onChange }) => {
    return (
      <div>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            onClick={() => onChange(star)}
            style={{
              cursor: "pointer",
              color: star <= value ? "#f59e0b" : "#d1d5db",
              fontSize: "20px",
              marginRight: "4px"
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };
  const submitFeedback = async (order) => {
    if (!userInfo) return;

    const payload = {
      orderId: order.orderId,
      userId: userInfo.id,


      overallRating,
      comment,
      itemRatings: order.items.map((item) => ({
        productTitle: item.name,
        rating: itemRatings[item.name] || 0,
      })),
    };

    try {
      await _post("/feedbacks/submitfeedback", payload);

      setSubmittedFeedbackOrders((prev) => [...prev, order.orderId]);

      setShowFeedbackFor(null);
      setOverallRating(0);
      setComment("");
      setItemRatings({});
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to submit feedback");
    }
  };



  const fetchOrderHistory = async (userId) => {
    try {
      setLoading(true);
      const response = await _get(`/orders/history/${userId}`);
      let order = response.data || response;

      const mappedOrders = order.map((ord) => ({
        ...ord,
        items: (ord.products || [])
          .filter((p) => p.active !== false)
          .map((p) => ({
            name: p.productTitle,
            price: p.offerPrice > 0 ? p.offerPrice : p.price,
            quantity: p.quantity,
            image:
              p.image ||
              (p.images && p.images.length > 0 ? p.images[0] : defaultImage),
          })),

        totalPrice: ord.amount,
        orderstatus: ord.status,
      }));

      let filteredOrders = mappedOrders;
      if (activeTab === "On Process") {
        filteredOrders = mappedOrders.filter(
          (order) =>
            order.orderstatus !== "completed" && order.orderstatus !== "reject"
        );
      } else if (activeTab === "Completed") {
        filteredOrders = mappedOrders.filter(
          (order) => order.orderstatus === "completed"
        );
      } else {
        filteredOrders = mappedOrders.filter(
          (order) => order.orderstatus === "reject"
        );
      }

      // console.log(
      //   `Filtered orders for tab "${activeTab}":`,
      //   filteredOrders.length
      // );

      setOrderHistoryData(filteredOrders);
    } catch (error) {
      // console.log("Error fetching order history:", error);
      setOrderHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) =>
    formatDateTimeInTimezone(dateString, timezone, locale);

  const toggleExpand = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  // pagination
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orderHistoryData.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );
  const totalPages = Math.ceil(orderHistoryData.length / ordersPerPage);

  return (
    <>
      {/* change 1 add dir=ltr for ltr align */}
      <section className="py-4 osahan-main-body d-block d-md-block" dir="ltr">
        <div className="container" style={{ zIndex: 1500 }}>
          <div className="p-3 d-flex align-items-center ">
            <h4 className="font-weight-bold m-0 text-red">{t("orders")}</h4>
            <span className="ml-auto " style={{ fontSize: "20px" }}>
              <IoClose
                onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>

          {/* Mobile Dropdown for Status Filter - ONLY FOR MOBILE */}
          <div className="d-block d-md-none px-3 mb-3">
            <select
              className="bg-white border-2 border-orange-200 rounded-xl shadow-md"
              value={activeTab}
              onChange={(e) => setActiveTab(e.target.value)}
              style={{
                fontSize: "0.875rem",
                padding: "10px 40px 10px 14px",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                color: "#1f2937",
                fontWeight: "600",
                width: "100%",
                border: "2px solid #fed7aa",
                outline: "none",
                borderRadius: "12px",
                lineHeight: "1.5",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23f97316'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                backgroundSize: "18px",
                cursor: "pointer",
              }}
            >
              <option value="On Process">⏱️ {t("onProcess")}</option>
              <option value="Completed">✓ {t("completed")}</option>
              <option value="Cancelled">✕ {t("cancelled")}</option>
            </select>
          </div>

          <div className="row">
            ,{/* LEFT SIDE TABS - ONLY FOR DESKTOP */}
            <div className="col-md-2 col-lg-2 mb-3 d-none d-md-block">
              <ul
                className="nav nav-tabsa custom-tabsa border-0 flex-column bg-white rounded-xl overflow-hidden shadow-md p-2 c-t-order"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <a
                    className={`nav-link border-0 text-dark py-3 ${activeTab === "Completed" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("Completed")}
                  >
                    <i className="feather-check mr-2 text-success mb-0"></i>{" "}
                    {t("completed")}
                  </a>
                </li>
                <li className="nav-item border-top " role="presentation">
                  <a
                    className={`nav-link border-0 text-dark py-3 ${activeTab === "On Process" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("On Process")}
                  >
                    <i className="feather-clock mr-2 text-warning mb-0"></i>{" "}
                    {t("onProcess")}
                  </a>
                </li>
                <li className="nav-item border-top" role="presentation">
                  <a
                    className={`nav-link border-0 text-dark py-3 ${activeTab === "Cancelled" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("Cancelled")}
                  >
                    <i className="feather-x-circle mr-2 text-danger mb-0"></i>{" "}
                    {t("cancelled")}
                  </a>
                </li>
              </ul>
            </div>
            {/* RIGHT SIDE ORDERS */}
            <div
              className="col-12 col-md-10 col-lg-8 col-xl-7 mx-auto"
              id="myTabContent"
            >
              {loading ? (
                <div className="p-3">{t("loadingOrders")}</div>
              ) : currentOrders.length === 0 ? (
                <div className="p-3">{t("noOrdersFound")}</div>
              ) : (
                currentOrders.map((order) => (
                  <div
                    className="tab-pane fade show active"
                    key={order.orderId}
                  >
                    <div className="order-body">
                      <div className="pb-2">
                        <div className="p-3 rounded-xl shadow-md bg-white border border-gray-100 hover:shadow-lg transition-all duration-300">
                          <div className="d-flex border-bottom pb-2 align-items-center order-header-wrapper">
                            {/* ✅ Only show image if order has items */}
                            {order.items.length > 0 && order.totalPrice > 0 ? (
                              <div className="text-muted mr-3">
                                <img
                                  alt="Product"
                                  src={
                                    order.items[0]?.image
                                      ? `${process.env.REACT_APP_IMAGE_BASE_URL}${order.items[0].image}`
                                      : (defaultImage
                                        ? `${process.env.REACT_APP_IMAGE_BASE_URL}${defaultImage}`
                                        : DEFAULT_IMAGE)
                                  }
                                  onError={(e) => {
                                    if (defaultImage && !e.target.src.includes(defaultImage)) {
                                      e.target.src = `${process.env.REACT_APP_IMAGE_BASE_URL}${defaultImage}`;
                                    } else {
                                      e.target.onerror = null;
                                      e.target.src = DEFAULT_IMAGE;
                                    }
                                  }}
                                  className="img-fluid order_img rounded-lg shadow-sm"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                className="text-center d-flex align-items-center justify-content-center bg-light rounded-lg mr-3 shadow-sm"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  color: "#aaa",
                                  fontSize: "24px",
                                }}
                              >
                                <i className="feather-x-circle"></i>
                              </div>
                            )}

                            {/* ✅ Order Info */}
                            <div className="flex-grow-1">
                              <p
                                className="mb-0 font-weight-bold"
                                style={{ fontSize: "0.9rem" }}
                              >
                                ORDER #{order.orderId}
                              </p>
                              <p
                                className="mb-0 text-muted"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <i className="feather-clock mr-1"></i>
                                {formatDate(order.createdAt)}
                              </p>
                            </div>

                            {/* ✅ Status Badge */}
                            <div className="ml-auto">
                              {order.orderstatus === "reject" ? (
                                <span
                                  className="px-3 py-1 rounded-full font-weight-bold bg-red-100 text-red-800"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  Cancelled
                                </span>
                              ) : order.orderstatus === "completed" ? (
                                <span
                                  className="px-3 py-1 rounded-full font-weight-bold bg-green-100 text-green-800"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  Completed
                                </span>
                              ) : (
                                <span
                                  className="px-3 py-1 rounded-full font-weight-bold bg-yellow-100 text-yellow-800"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {order.orderstatus}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="pt-2">
                            {order.items.length === 0 ? (
                              <div
                                className="text-muted py-1"
                                style={{ fontSize: "0.8rem" }}
                              >
                                <em>{t("orderCancelledOrRemoved")}</em>
                              </div>
                            ) : (
                              <>
                                <ul className="item p-0 mb-2">
                                  {order.items.map((item, id) => {
                                    // If not expanded, hide items after the first 2
                                    if (
                                      expandedOrderId !== order.orderId &&
                                      id >= 2
                                    )
                                      return null;

                                    return (
                                      <li
                                        key={id}
                                        style={{
                                          listStyleType: "none",
                                          fontSize: "0.85rem",
                                        }}
                                        className="mb-1 py-1 border-bottom"
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span className="font-weight-semibold text-gray-800">
                                            {item.name} x {item.quantity}
                                          </span>
                                          <span className="text-dark font-weight-bold">
                                            {formatCurrency(item.price * item.quantity, locale)}

                                          </span>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>

                                {order.items.length > 2 && (
                                  <a
                                    href="#toggle"
                                    className="text-orange-600 font-weight-bold hover:text-orange-700 transition-colors"
                                    style={{
                                      textDecoration: "none",
                                      fontSize: "0.8rem",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleExpand(order.orderId);
                                    }}
                                  >
                                    {expandedOrderId === order.orderId
                                      ? t("showFewerItems")
                                      : t("showMoreItems")}
                                  </a>
                                )}
                              </>
                            )}
                          </div>

                          <div className="d-flex justify-content-between align-items-center pt-2 mt-2 border-top total-payment-wrapper">
                            <span
                              className="text-muted font-weight-semibold"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {t("totalPayment")}
                            </span>
                            <span
                              className="text-dark font-weight-bold"
                              style={{ fontSize: "1.1rem" }}
                            >

                              {formatCurrency(order.totalPrice, locale)}
                            </span>
                          </div>
                          {order.orderstatus === "completed" && (
                            <div className="mt-3">
                              {submittedFeedbackOrders.includes(order.orderId) ? (
                                <span
                                  className="text-success font-weight-bold"
                                  style={{ fontSize: "0.85rem" }}
                                >
                                  Feedback Submitted
                                </span>
                              ) : (
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() =>
                                    setShowFeedbackFor(
                                      showFeedbackFor === order.orderId ? null : order.orderId
                                    )
                                  }
                                >
                                  {showFeedbackFor === order.orderId
                                    ? "Close Feedback"
                                    : "Give Feedback"}
                                </button>
                              )}
                            </div>
                          )}

                          {showFeedbackFor === order.orderId && !submittedFeedbackOrders.includes(order.orderId) && (
                            <div className="mt-2 p-2 border rounded bg-light">

                              {/* Overall Rating */}
                              <div
                                className="d-flex align-items-center justify-content-between mb-2"
                                style={{ fontSize: "0.85rem" }}
                              >
                                <span
                                  className="font-weight-bold text-gray-800"
                                  style={{
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  Overall Rating
                                </span>

                                <StarRating value={overallRating} onChange={setOverallRating} />
                              </div>

                              {/* Item Ratings – Inline */}
                              {order.items.map((item, index) => (
                                <div
                                  key={index}
                                  className="d-flex align-items-center justify-content-between mb-1"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  <span
                                    style={{
                                      maxWidth: "65%",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {item.name}
                                  </span>
                                  <StarRating
                                    value={itemRatings[item.name] || 0}
                                    onChange={(rating) =>
                                      setItemRatings({
                                        ...itemRatings,
                                        [item.name]: rating,
                                      })
                                    }
                                  />
                                </div>
                              ))}

                              {/* Comment */}
                              <textarea
                                className="form-control form-control-sm mt-2"
                                rows="2"
                                placeholder="Optional comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />

                              {/* Submit */}
                              <div className="text-center mt-2">
                                <button
                                  onClick={() => submitFeedback(order)}
                                  disabled={overallRating === 0}
                                  className="btn btn-sm px-3 text-white"
                                  style={{
                                    background:
                                      overallRating === 0
                                        ? "#fed7aa"
                                        : "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
                                    border: "none",
                                    fontWeight: 600,
                                    cursor: overallRating === 0 ? "not-allowed" : "pointer",
                                  }}
                                >
                                  Submit
                                </button>

                              </div>
                            </div>
                          )}



                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center my-3">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    className="btn btn-sm btn-outline-secondary mx-1"
                  >
                    Prev
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .map((pageNum, idx, arr) => {
                      if (
                        pageNum === 1 ||
                        pageNum === totalPages ||
                        (pageNum >= currentPage - 1 &&
                          pageNum <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            className={`btn btn-sm mx-1 ${currentPage === pageNum
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                          >
                            {pageNum}
                          </button>
                        );
                      }

                      const prevPage = arr[idx - 1];
                      const nextPage = arr[idx + 1];
                      if (
                        prevPage &&
                        prevPage < pageNum - 1 &&
                        nextPage &&
                        nextPage > pageNum + 1
                      ) {
                        return (
                          <span key={pageNum} className="mx-1">
                            ...
                          </span>
                        );
                      }

                      return null;
                    })

                    .filter((item, index, self) => {
                      return !(
                        typeof item === "string" &&
                        item === "..." &&
                        self[index - 1] === "..."
                      );
                    })}

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    className="btn btn-sm btn-outline-secondary mx-1"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Orders;
